import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Loader2, ArrowRight, Check } from "lucide-react";

/** Consented marketing signup — first-party, unsubscribe link in every send. */
export const NewsletterSignup = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async () => {
    const v = email.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) return toast.error("Enter a valid email");
    setBusy(true);
    try {
      await api.post("/newsletter/subscribe", { email: v, source: "landing_footer" });
      setDone(true);
      toast.success("You're on the list");
    } catch (e) { toast.error(e.response?.data?.detail || "Could not subscribe"); }
    finally { setBusy(false); }
  };

  if (done) {
    return (
      <div className="flex items-center gap-2 text-sm text-cyan" data-testid="newsletter-done">
        <Check size={16} /> You're on the list — one growth teardown a week, unsubscribe any time.
      </div>
    );
  }

  return (
    <div className="max-w-md" data-testid="newsletter-signup">
      <p className="text-sm text-slate-400">One local-business growth teardown a week. No spam, unsubscribe in a click.</p>
      <div className="mt-3 flex overflow-hidden rounded-full border border-white/15 bg-white/[0.04] focus-within:border-cyan/60">
        <input data-testid="newsletter-email" value={email} onChange={(e) => setEmail(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && submit()} placeholder="you@yourbusiness.com" type="email"
          aria-label="Email address"
          className="min-w-0 flex-1 bg-transparent px-4 py-2.5 text-sm text-white placeholder:text-slate-500 focus:outline-none" />
        <button data-testid="newsletter-submit" onClick={submit} disabled={busy}
          className="flex shrink-0 items-center gap-1 bg-gradient-to-r from-klein to-cyan px-4 text-sm font-semibold text-brand-dark transition-opacity hover:opacity-90 disabled:opacity-60">
          {busy ? <Loader2 size={15} className="animate-spin" /> : <>Subscribe <ArrowRight size={14} /></>}
        </button>
      </div>
    </div>
  );
};

export default NewsletterSignup;
